module.exports = __webpack_public_path__ + "static/img/logo.4676a51.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/page/img/logo.png
// module id = J/2A
// module chunks = 1